import React, { useCallback } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { PERMISSION_ACTIONS } from 'data/permissionActions';
import { PERMISSION_SUBJECTS } from 'data/permissionSubjects';
import ErrorLayout from 'components/ErrorLayout';
import WithPermissions from 'components/WithPermissions';

export default function ProtectedRoute({ children, subject, permissions }) {
  const navigate = useNavigate();

  const handleGoToHome = useCallback(() => {
    navigate('/');
  }, [navigate]);

  return (
    <WithPermissions
      subject={subject}
      permissions={permissions}
      fallback={
        <ErrorLayout
          title="Oh no! We couldn’t find it"
          message="Please try again later"
          actionFn={handleGoToHome}
          actionLabel="Go To Home"
        />
      }
    >
      {children ? children : <Outlet />}
    </WithPermissions>
  );
}

ProtectedRoute.propTypes = {
  subject: PropTypes.oneOf(Object.values(PERMISSION_SUBJECTS)).isRequired,
  permissions: PropTypes.arrayOf(
    PropTypes.oneOf(Object.values(PERMISSION_ACTIONS))
  ).isRequired,
  children: PropTypes.node.isRequired,
};
